import { objectOf, maybe, enumOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";
import { boolean } from "@altostra/type-validations/lib/primitives";

import type { SegmentCohortsExecuteTextToSqlResult, SegmentCohortsTextToSqlStatus } from "./types";

export const isSegmentCohortsExecuteTextToSqlResult = objectOf<SegmentCohortsExecuteTextToSqlResult>({
  status: enumOf<SegmentCohortsTextToSqlStatus>("success", "error"),
  error_message: maybe(string),
  sql: maybe(string),
  inverted: maybe(boolean),
});
